import { useEffect, useState } from "react";

const FONT_SCALE_KEY = "todoit-font-scale";
const FONT_SCALES = [100, 112.5, 125, 150];

const getStoredScaleIndex = (): number => {
  try {
    const stored = Number(window.localStorage.getItem(FONT_SCALE_KEY));
    const index = FONT_SCALES.indexOf(stored);
    if (index !== -1) return index;
  } catch {}
  return 0;
};

export const FontSizeControl = () => {
  const [index, setIndex] = useState(getStoredScaleIndex);

  // Scale the root font size as a percentage so it builds on the browser's own
  // default size; Tailwind sizes are rem-based, so everything scales with it.
  useEffect(() => {
    document.documentElement.style.fontSize = `${FONT_SCALES[index]}%`;
    try {
      window.localStorage.setItem(FONT_SCALE_KEY, String(FONT_SCALES[index]));
    } catch {}
  }, [index]);

  const buttonClass =
    "min-h-10 min-w-10 sm:min-h-0 sm:min-w-0 px-2 py-1 rounded bg-neutral-100 text-neutral-700 disabled:opacity-40";

  return (
    <div className="flex items-center gap-1" role="group" aria-label="Text size">
      <button
        onClick={() => setIndex((i) => Math.max(0, i - 1))}
        disabled={index === 0}
        aria-label="Decrease text size"
        className={`${buttonClass} text-xs`}
      >
        A
      </button>
      <button
        onClick={() => setIndex((i) => Math.min(FONT_SCALES.length - 1, i + 1))}
        disabled={index === FONT_SCALES.length - 1}
        aria-label="Increase text size"
        className={`${buttonClass} text-base`}
      >
        A
      </button>
    </div>
  );
};
